import React from 'react';
// import styles from '../style';

const About = () => (
  <section className="flex flex-col md:mx-[65px] mx-[1.7rem] md:px-5 justify-items-stretch my-[3rem] font-thin text-dimWhite  md:text-[24px] text-[25px]">
    <p className="my-5 md:leading-[40.8px] leading-[32.8px]">
      In addition to my carreer, I love using my time on
      a variety of activities and projects, such as reading
      pop culture, neuronal and general sciences, or walking
      the city. I like to practice activities like meditation,
      anaerobic exercise, and playing music.
    </p>
    <p className="my-5 md:leading-[40.8px] leading-[32.8px]">
      When not on that, I&apos;ll be diving on web tech.
    </p>
  </section>
);

export default About;
